import { render, staticRenderFns } from "./OrgGroups.vue?vue&type=template&id=1d930e14&scoped=true&"
import script from "./OrgGroups.vue?vue&type=script&lang=js&"
export * from "./OrgGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d930e14",
  null
  
)

export default component.exports